<template>
    <div class="implementProject">
        <leftnav class="fl" :mkcode="classId>10 || classId==6?yj_mkcode:'F'" :itemcode="yj_itemcode" docutitle="落项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="current title" >落项目</span>
                    </div>
                    <div class="opport-screen-list1">
							<dl class="opport-screen bdbe">
								<dt class="fl">分类</dt>
								<dd class="fl">
									<span :class="classId == list.value?'a-screen current':'a-screen'"
										@click="hanlderClass(list)" :key="i"
										v-for="(list,i) in classList">{{list.name}}({{list.num }})
									</span>
								</dd>
							</dl>
						</div>
                </div>
                <div class="enterprise_list_box whitebox ">
                    <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="enterpristlist.length>0">
							<tr>
								<th>项目名称</th>
								<th>企业名称</th>
								<th>产业类型</th>
								<th>项目类型</th>
								<th>项目状态</th>
								<th>落地诉求</th>
								<th>政策诉求</th>
								<th>项目简介</th>
								<!-- <th>工作协助</th> -->
							</tr>
                            <tr v-for="item in enterpristlist" :key="item.stockcode">
                                <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">{{item.project || '-'}}</td>
                                <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">{{item.customerName || '-'}}</td>
                                <td>{{item.smallClassText || '-'}}</td>
                                <td>{{item.projectTypeText || '-'}}</td>
                                <td>{{item.statusText || '-'}}</td>
                                <td class='cur-pointer bluefont' @click="initiatePopup(item,6)"><p class="summary-td">{{item.landing || '-'}}</p></td>
                                <td class='cur-pointer bluefont' @click="initiatePopup(item,4)"><p class="summary-td">{{item.policy || '-'}}</p></td>
                                <td class='cur-pointer bluefont' @click="initiatePopup(item,5)"><p class="summary-td">{{item.summary || '-'}}</p></td>
                                <!-- <td v-show="currentTab == 1" class="cur-pointer bluefont" @click="initiatePopup(item,1)"> 发起> </td>
                                <td v-show="currentTab == 1" class="cur-pointer bluefont" @click="initiatePopup(item,3)"> 结果> </td>
                                <td v-show="currentTab == 1" class="cur-pointer bluefont" @click="initiatePopup(item,2)"> 接收> </td> -->
                            </tr>
                </table>
                </div>
                <div class="centerpage1 company_pagelist" v-show="totalPage>1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>
                <el-dialog class="localChain" custom-class="initiate_box_dialog" :title="dialog.dialogTitle" center :visible.sync="isInitiate" top="25vh">
                    <div class="initiate_box"> 
                        <div v-show="dialog.dialogType == 1">
                            <el-row class="mb-1">
                            <el-col :span="4" class="initiate_title">请选择协助人：</el-col>
                            <el-col :span="20">
                                <el-select v-model="form.assistantValue" placeholder="请选择">
                                    <el-option v-for="item in assistantList" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="4" class="initiate_title">申请协作内容：</el-col>
                            <el-col :span="20">
                                <el-input type="textarea" v-model="form.content" :rows="4" placeholder="请输入评估需求"></el-input>
                            </el-col>
                        </el-row>
                        </div>
                        <el-row class="mb-1" v-show="dialog.dialogType == 2">
                            <el-col :span="4" class="initiate_title">协作反馈：</el-col>
                            <el-col :span="20">
                                <el-input type="textarea" v-model="form.content" :rows="4" placeholder="请输入评估需求"></el-input>
                            </el-col>
                        </el-row>
                        <el-row class="mb-1" v-show="dialog.dialogType == 3">
                            <el-col :span="4" class="initiate_title">协作反馈：</el-col>
                            <el-col :span="20">
                                <p>协作反馈内容展示协作反馈内容展示协作反馈内容展示协作反馈内容展示协作反馈内容展示</p>
                            </el-col>
                        </el-row>
                        <el-row class="mb-1" v-show="dialog.dialogType == 4 || dialog.dialogType == 5|| dialog.dialogType == 6">
                            <el-col :span="24">
                                <p>{{temDialogText}}</p>
                            </el-col>
                        </el-row>
                    </div>
                    <span slot="footer" class="dialog-footer" v-show="dialog.dialogType == 1 || dialog.dialogType == 2">
                        <el-button @click="closeInitiate">取 消</el-button>
                        <el-button type="primary" @click="submitInitiate">提 交</el-button>
                    </span>
                </el-dialog>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'implementProject',
    data() {
        return {
            currentTab: '1',
            userdata: {},
            tabList: [
                { value: '1', text: '落项目', path: '/findProjects' },
                // { value: '2', text: '已评项目', path: '/enterpriseList?type=9' },
            ],
            yj_mkcode: 'G',
            yj_itemcode: 'G-qbxm',
            enterpristlist: [ ],
            classList: [
                { name: '全部项目', num: 0 ,value: 6,itemcode:'G-qbxm'},
                { name: '项目对接中', num: 0 ,value: 7,itemcode:'G-xmdjz'},
                { name: '已智慧选址', num: 0,value: 8 ,itemcode:'G-yzhxz'} ,
                { name: '已实地考察', num: 0,value: 9,itemcode:'G-ysdkc' },
                { name: '项目谈判中', num: 0,value: 10 ,itemcode:'G-xmtpz'},
                { name: '已落地签约', num: 0,value: 11 ,itemcode:'G-yldqy'},
                { name: '已购地租厂', num: 0,value: 12 ,itemcode:'G-ygdzc'},
                { name: '已开工建设', num: 0,value: 13 ,itemcode:'G-ykgjs'},
                { name: '已生产运营', num: 0,value: 14 ,itemcode:'G-yscyy'},
                { name: '暂停跟踪', num: 0,value: 20 ,itemcode:'G-ztxm'},
            ],
            classId: 6,
            assistantList: [
                { value: '1', label: '张三' },
                { value: '2', label: '李四' },
                { value: '3', label: '王五' },
            ],
            isInitiate: false,
            form: {
                assistantValue: '',
                content: '',
            },
            dialog:{
                dialogType: 1, //1发起协作 2协作反馈 3查看反馈结果
                dialogTitle: '工作协助',
            },
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            temDialogText:'',
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse,}),
        ...mapGetters(['isCollapse'])
    },

    components: {
    },
    mounted() {
        this.getClassList();
        this.ajaxsearchcompany(1);
    },
    created() {
        this.userdata = this.getuseriformation();
        this.classId = this.$route.query.type ;
        
        //currentTab匹配tabList，把对应的itemcode赋值给yj_itemcode
        let currentTabItem = this.classList.find(item => item.value == this.classId);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
    },
    //监听路由变化
    watch: {
        $route: function (newVal, oldVal) {
            this.classId = this.$route.query.type;
            let currentTabItem = this.classList.find(item => item.value == this.classId);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
            this.ajaxsearchcompany(1);
        }
    },
    methods: {
         getClassList() {
            // 获取项目分类
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl = this.$api.crm.parameter.menuList();
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    let datalist = res.data.list;
                    let resultlist = [];
                    //对比 如果classList 和 datalist有相同的value，则把datalist的num赋给classList
                    _this.classList.forEach(classItem => {
                        let matchItem = datalist.find(dataItem => dataItem.value == classItem.value);
                        if (matchItem) {
                            classItem.num = matchItem.num;
                        }
                    });
                    _this.bus.$emit('loading', false);
                }
            })
        },
        //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        // 项目分类选择
        hanlderClass(item) {
            this.yj_itemcode = item.itemcode;
            this.classId = item.value;
            this.ajaxsearchcompany(1);
        },
        // 关闭项目评估弹框
        closeInitiate() {
            this.isInitiate = false;
        },
        // 提交项目评估
        submitInitiate() {
            this.isInitiate = false;
        },
        //发起项目评估弹框
        initiatePopup(item,type) {
            // console.log("发起项目评估", item);
            this.dialog.dialogType = type;
            // this.dialog.dialogTitle = type == 1 ? '工作协助' : type == 2 ? '协作反馈' : '查看反馈结果';
            switch (type) {
                case 1:
                    this.dialog.dialogTitle = '工作协助';
                    break;
                case 2:
                    this.dialog.dialogTitle = '协作反馈';
                    break;
                case 3:
                    this.dialog.dialogTitle = '查看反馈结果';
                    break;
                case 4:
                    this.dialog.dialogTitle = '政策诉求';
                    this.temDialogText = item.policy;
                    break;
                case 5:
                    this.dialog.dialogTitle = '项目简介';
                    this.temDialogText = item.summary;
                    break;
                case 6:
                    this.dialog.dialogTitle = '落地诉求';
                    this.temDialogText = item.landing;
                    break;
                default:
                    break;
            }
            this.isInitiate = true;
        },
        // 标签切换
        tabClick(item) {
            this.currentTab = item.value;
        },
        ajaxsearchcompany(page) {
            // 获取企业列表
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.project.list()+'?page='+page+'&pageSize='+this.pageSize+'&menu='+this.classId;
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数
                   

                } else {
                    _this.$message.error(res.data.msg);
                }
                 _this.bus.$emit('loading', false);
            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function(page) {
				this.ajaxsearchcompany(page, 'sort', 'search');
			},
    }
}
</script>

<style scoped lang="scss">
.enterprise_list_box{
    min-height: 75vh;
}
.initiate_box{
    font-size: 16px;
}
.initiate_title{
    font-weight: 600;
}
.initiate_box_dialog{
    border-radius: 10px;
}
.summary-td{
    // width: 100%;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;           //特别显示模式
    -webkit-line-clamp: 1;          //行数
    line-clamp: 1;                  
    -webkit-box-orient: vertical;   //盒子中内容竖直排列 
    line-height: 70px;
 }
</style>